export const API = process.env.REACT_APP_LANDINGPAGE_API
export const GMB = process.env.REACT_APP_GMB_API
